const MCP_PASSWORD_CHARS =
  "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%&*"

export const generateMcpPassword = (length = 24) => {
  const bytes = new Uint8Array(length)
  crypto.getRandomValues(bytes)
  return Array.from(
    bytes,
    (byte) => MCP_PASSWORD_CHARS[byte % MCP_PASSWORD_CHARS.length]
  ).join("")
}
